export default function ViewTaskDetailsForm() {
  return (
    <div>
      <h1>ViewTaskDetailsForm</h1>
    </div>
  );
}
